import type { PropsWithChildren } from "react";

export const HeaderLeftPanel = ({
  children,
}: PropsWithChildren<Record<string, unknown>>) => (
  <div className="flex flex-1 flex-row items-center">{children}</div>
);
